import { StateDropdownConfig } from '@st/ui-config'
import { Dropdown } from './dropdown'
import { US_STATES } from '@util/us-states'
import { useInputValue } from '@st/react-util/form-binding'
import { toStr } from '@st/util/cast'
import { QuestionnairePageValidationResult } from '@features/st-questionnaire/st-questionnaire-validation'
import { hasValidationError } from '@features/st-folder-viewer/st-folder-questionnaire'
import { clsx } from 'clsx'

export function WizardStateDropdown({
  config,
  validationResult
}: {
  config: StateDropdownConfig
  validationResult: QuestionnairePageValidationResult
}) {
  const [state, setState] = useInputValue(config.userInputKey, toStr)

  return (
    <Dropdown
      className={clsx({
        'ring-red-500': hasValidationError(validationResult, config.userInputKey)
      })}
      label={config.label}
      options={US_STATES.map((state) => ({ key: state.code, label: state.name }))}
      value={state}
      onChange={setState}
    />
  )
}
